import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao07',
  templateUrl: './leilao07.component.html',
  styleUrls: ['./leilao07.component.scss']
})
export class Leilao07Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }

}
